import type { SiteSearchDocument, SiteSearchHit } from "@/lib/site-search";
import { useEffect, useMemo, useState } from "react";

type SearchEngine = typeof import("@/lib/site-search-engine");

export function useSiteSearchHits(
  documents: SiteSearchDocument[],
  query: string,
  limit: number,
  enabled: boolean,
) {
  const [engine, setEngine] = useState<SearchEngine | null>(null);

  useEffect(() => {
    if (!enabled || engine) return;
    let active = true;
    void import("@/lib/site-search-engine").then((module) => {
      if (active) setEngine(module);
    });
    return () => {
      active = false;
    };
  }, [enabled, engine]);

  const index = useMemo(
    () => (engine ? engine.createSiteSearchIndex(documents) : null),
    [documents, engine],
  );
  const results = useMemo<SiteSearchHit[]>(
    () => (index && engine ? engine.searchSiteIndex(index, query, limit) : []),
    [engine, index, limit, query],
  );

  return { results, ready: engine !== null };
}
